import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"
import Scrollable from "@/common/components/scrollable"
import { ReactComponent as CustomImage } from "@/images/signomatic/custom.svg"
import { ReactComponent as NoneImage } from "@/images/signomatic/none.svg"
import AutoGrid from "@/signomatic/components/auto_grid"
import ColorUtil from "@/signomatic/util/colors"

interface MultiColorPickerProps {
  colors: string[]
  current?: string
  showNone: boolean
  onChange: (color?: string) => void
  onCustom: (e: React.MouseEvent) => void
  customPicker: React.ReactNode
  patternButton: React.ReactNode
}

const MultiColorPicker: React.FC<MultiColorPickerProps> = ({
  colors,
  current,
  showNone,
  patternButton,
  customPicker,
  onChange,
  onCustom,
}) => {
  const { t } = useTranslation()

  const picker = (
    <>
      <AutoGrid>
        {showNone && (
          <div className={cn("color-button none", { active: !current })} onClick={() => onChange()}>
            <div className="color-wrapper">
              <div className="color-background"></div>
              <div className="color">
                <NoneImage />
              </div>
            </div>
            <div className="name">
              <p className="paragraph-2xs center mb-0">{t(`toolbox.none`)}</p>
            </div>
          </div>
        )}
        <div
          className={cn("color-button", "custom", {
            active: current && !colors.includes(current),
          })}
          onClick={onCustom}
        >
          <div className="color-wrapper">
            <div className="color-background"></div>
            <div className="color">
              <CustomImage />
            </div>
          </div>
          <div className="name">
            <p className="paragraph-2xs center mb-0">{t(`toolbox.custom`)}</p>
          </div>
        </div>
        {colors.map(color => (
          <div
            key={color}
            className={cn("color-button", ColorUtil.colorClass(color), `color-${ColorUtil.colorClass(color)}`, {
              active: current === color,
            })}
            onClick={() => onChange(color)}
          >
            <div className="color-wrapper">
              <div className="color-background"></div>
              <div
                className="color"
                style={{ backgroundColor: color, backgroundImage: ColorUtil.backgroundImage(color) }}
              />
            </div>
            <div className="name">
              <p className="paragraph-2xs center mb-0">{t(`background_colors.${color}`)}</p>
            </div>
          </div>
        ))}
        {patternButton}
      </AutoGrid>
      {customPicker}
    </>
  )

  return window.innerWidth <= 1023 ? (
    <Scrollable>
      <div className="color-picker multi-color-picker">{picker}</div>
    </Scrollable>
  ) : (
    <div className="color-picker multi-color-picker">{picker}</div>
  )
}

export default MultiColorPicker
